<template>
  <DialogTemplate>
    <div class="pt-2 mr-4">
      <div class="text-large weight_700 clr-primary">
        {{ $t('tips.study.eq_buckets.title') }}
      </div>
      <div class="f-align-center pb-1 weight_700 mt-4">
        <v-icon class="mr-2">mdi-layers-outline</v-icon>
        {{ $t('browse.eq_buckets_simple') }}
      </div>
      <div class="ml-8">
        <div>{{ $t('browse.eq_buckets.help_title') }}</div>
        <div class="mt-2 mb-2 uppercase">
          <ul>
            <li
              v-for="item in opts"
              :key="item.name"
              style="white-space: nowrap"
            >
              <div class="d-flex">
                <div style="width: 9rem">
                  {{ item.name }}
                </div>
                <div
                  class="text-left"
                  style="width: 4rem"
                >
                  {{ item.percent }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="f-align-center pb-1 weight_700 mt-4">
        <v-icon class="mr-2">mdi-layers-triple-outline</v-icon>
        {{ $t('browse.eq_buckets_advanced') }}
      </div>
      <div class="ml-8">
        <div>{{ $t('tips.study.eq_buckets.advanced_sub') }}</div>
      </div>

      <div class="f-align-center pb-1 weight_700 mt-4">
        <v-icon class="mr-2">mdi-lightbulb-on-outline</v-icon>
        {{ $t('tips.study.eq_buckets.other_tips') }}
      </div>
      <div class="ml-8">
        <ul>
          <li
            v-for="item in optsTips"
            :key="item.name"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyEqBucketsHelpDialog',
  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    opts() {
      return [
        { name: this.$t('browse.eq_buckets.best_hands'), percent: '100% - 75%' },
        { name: this.$t('browse.eq_buckets.good_hands'), percent: '75% - 50%' },
        { name: this.$t('browse.eq_buckets.weak_hands'), percent: '50% - 33%' },
        { name: this.$t('browse.eq_buckets.trash_hands'), percent: '33% - 0%' },
      ]
    },
    optsTips() {
      return [
        { name: this.$t('tips.study.eq_buckets.filter_eq') },
        { name: this.$t('tips.study.eq_buckets.switch_eq') },
        { name: this.$t('tips.study.eq_buckets.mouseover_eq') },
        {
          name: this.$t('tips.study.eq_buckets.press_hotkey', {
            key: this.hotkeys.study_fullscreen_mode.displayCombination,
          }),
        },
      ]
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
  },
}
</script>
